import {DateTime} from 'luxon';

export type PeriodPresetKey = 'today' | 'week' | 'month' | '30d' | '90d';

export interface IPeriodRange {
  startDate: string;
  endDate: string;
  label: string;
}

export const PERIOD_PRESETS: Array<{ key: PeriodPresetKey; label: string }> = [
  {key: 'today', label: 'היום'},
  {key: 'week', label: 'השבוע'},
  {key: 'month', label: 'החודש'},
  {key: '30d', label: '30 ימים'},
  {key: '90d', label: '90 ימים'},
];

export const presetRange = (key: PeriodPresetKey): IPeriodRange => {
  // Business timezone, not the viewing device's
  const now = DateTime.local({zone: 'Asia/Jerusalem'});
  const label = PERIOD_PRESETS.find(p => p.key === key)?.label ?? '';
  switch (key) {
    case 'today':
      return {startDate: now.toISODate() ?? '', endDate: now.toISODate() ?? '', label};
    case 'week':
      // Israeli week starts on Sunday (luxon startOf('week') is Monday)
      return {startDate: now.minus({days: now.weekday % 7}).toISODate() ?? '', endDate: now.toISODate() ?? '', label};
    case 'month':
      return {startDate: now.startOf('month').toISODate() ?? '', endDate: now.toISODate() ?? '', label};
    case '30d':
      return {startDate: now.minus({days: 30}).toISODate() ?? '', endDate: now.toISODate() ?? '', label};
    case '90d':
      return {startDate: now.minus({days: 90}).toISODate() ?? '', endDate: now.toISODate() ?? '', label};
  }
};
